// extracted by mini-css-extract-plugin
export default {"TooltipIcon":"TooltipIcon_TooltipIcon__fO+cC","Tooltip":"TooltipIcon_Tooltip__NF-ar","HeaderTooltip":"TooltipIcon_HeaderTooltip__ERtNj"};